module.exports = __webpack_public_path__ + "img/teacher4.ee1b7867.jpg";